import { object, string } from '~utils/validation';

export default object({
  cpf: string().max(14).required(),
});
